// extracted by mini-css-extract-plugin
module.exports = {"actionArea":"Offer_actionArea__Ci-uV"};